import React from 'react';
import PropTypes from 'prop-types';
import {Bar} from 'react-chartjs-2';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider
} from '@material-ui/core';
import {currencyKr} from 'helpers/currencyKr';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    chartContainer: {
        position: 'relative'
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    }
}));

const GraphForLast30Days = props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const {points, deals} = data;
    const getChartData = ({points, deals}) => {
        const chartData = {
            datasets: [
                {
                    label: 'D-30 Revenue',
                    type: 'line',
                    data: points.data,
                    fill: false,
                    borderColor: theme.palette.info.main,
                    backgroundColor: theme.palette.info.main,

                    pointBorderColor: theme.palette.info.dark,
                    pointBackgroundColor: theme.palette.info.dark,

                    pointHoverBackgroundColor: theme.palette.info.dark,
                    pointHoverBorderColor: theme.palette.info.dark,
                    yAxisID: 'y-axis-1'
                }, {
                    type: 'bar',
                    label: 'D-30 Total Deals',
                    data: deals.data,
                    fill: false,
                    backgroundColor: theme.palette.success.main,
                    borderColor: theme.palette.success.main,
                    hoverBackgroundColor: theme.palette.success.dark,
                    hoverBorderColor: theme.palette.success.dark,
                    yAxisID: 'y-axis-2'
                }]
        };
        const chartOptions = {
            responsive: true,
            labels: points.labels,
            tooltips: {
                mode: 'nearest',
                callbacks: {
                    label: tooltipItem =>
                        tooltipItem.datasetIndex === 0 ?
                            currencyKr(tooltipItem.yLabel) :
                            `${tooltipItem.yLabel} count`
                },
            },
            elements: {
                line: {
                    fill: false
                }
            },
            scales: {
                xAxes: [
                    {
                        display: true,
                        gridLines: {
                            display: false
                        },
                        labels: points.labels
                    }
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true
                        },
                        ticks: {
                            beginAtZero: true
                        }
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-2',
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true
                        },
                        ticks: {
                            beginAtZero: true,
                            max: Math.max(...deals.data) * 3
                            // max: 15000
                        }
                    }
                ]
            }
        };

        return {
            data: chartData,
            options: chartOptions
        };
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader
                title="D-30 Graph"
            />
            <Divider/>
            {points && deals && (
                <CardContent>
                    <div className={classes.chartContainer}>
                        <Bar {...getChartData({points, deals})}/>
                    </div>
                </CardContent>
            )}
        </Card>
    );
};

GraphForLast30Days.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired
};

export default GraphForLast30Days;
